const options = {
    autoHeight: true,
    grabCursor: true,
    keyboard: true,
    navigation: {
        prevEl: '.js-events-timeline-slider-prev',
        nextEl: '.js-events-timeline-slider-next',
        disabledClass: 'hidden',
    },
    spaceBetween: 20,
    slidesPerView: 'auto',
    breakpoints: {
        768: {
            slidesPerView: 'auto',
            spaceBetween: 30,
            autoHeight: false,
        },
        1350: {
            slidesPerView: 4,
            spaceBetween: 30,
            autoHeight: false,
        },
    },
};

const sliderEventsTimeline = {
    init() {
        const elements = document.querySelectorAll('.js-events-timeline-slider');

        if (!elements.length) return;

        this.sliderEventsTimeline = [];

        elements.forEach((element) => {
            const Slider = slider.default;
            this.sliderEventsTimeline.push(new Slider(element, options));
        });
    },
};

export default sliderEventsTimeline;
